<div class="modal-header">
    <h5 class="modal-title">{{setting.settingName}}</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[settingsForm]"></dirty-tracking>
<form class="" novalidate #settingsForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <div class="row gx-3" [ngSwitch]="setting.settingType">
            <div class="col-md mb-3" *ngSwitchCase="pdxSystemSettingType.String">
                <input type="text" name="stringValue" class="form-control form-control-lg" [placeholder]="setting.settingName" required [(ngModel)]="setting.editValue" focus-me />
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3" *ngSwitchCase="pdxSystemSettingType.EncryptedString">
                <input type="password" name="encryptedStringValue" class="form-control form-control-lg" [placeholder]="setting.settingName" required [(ngModel)]="setting.editValue" focus-me />
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3" *ngSwitchCase="pdxSystemSettingType.WYSIWYG">
                <ckeditor [editor]="Editor" [(ngModel)]="setting.editValue" name="wysiwygValue" [config]="config" #editor (ready)="onEditorReady($event)"></ckeditor>
                <input type="hidden" name="editValue" class="form-control" required [(ngModel)]="setting.editValue" />
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>
            Save</button>
    </div>
</form>